import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance        from './axiosInstance';
import { AuthContext }      from './context/AuthContext';
import './styles/SolumToolSuiteLayout.css'; // Reuse existing styles

function SolumSaasSuiteLayout({ children, isDropdown = false }) {
  /* ── menu toggle ─────────────────────────────────────────────── */
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef         = useRef(null);

  const toggleMenu = () => setIsOpen(prev => !prev);

  useEffect(() => {
    /* close if clicked outside */
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  /* ── auth + logout ───────────────────────────────────────────── */
  const { user, refreshUser } = useContext(AuthContext);
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await axiosInstance.post('auth/logout');   // clears cookie server-side
      await refreshUser();                       // wipe context client-side
      navigate('/login');
    } catch (err) {
      console.error('Logout failed', err);
    }
  }

  /* ── shared menu markup (ul > li list) ───────────────────────── */
  const MenuList = () => (
    <ul>
      <li className="greeting">
        Hello&nbsp;<strong>{user?.displayName || 'friend'}</strong>&nbsp;
        (<span onClick={handleLogout} className="logout-link">logout</span>)
      </li>

      <li onClick={() => setIsOpen(false)}>
        <Link to="/main-homepage">Home</Link>
      </li>

      {/* ✅ All SaaS Suite pages require Admin or Super Admin access */}
      {(user?.role === 'admin' || user?.isSuperAdmin) && (
        <>
          <li onClick={() => setIsOpen(false)}>
            <Link to="/gateway-tester">Gateway Tester</Link>
          </li>
          <li onClick={() => setIsOpen(false)}>
            <Link to="/function-assignment">Function Assignment</Link>
          </li>
          <li onClick={() => setIsOpen(false)}>
            <Link to="/offline-labels">Offline Labels Manager</Link>
          </li>
          <li onClick={() => setIsOpen(false)}>
            <Link to="/offline-gateways">Offline Gateway Analysis</Link>
          </li>
        </>
      )}
    </ul>
  );

  /* ── DROPDOWN  (mobile / right-hand) ─────────────────────────── */
  if (isDropdown) {
    return (
      <div className="DropdownMenu" ref={dropdownRef}>
        <button className="DropdownButton" onClick={toggleMenu}>
          ☰ Apps
        </button>

        {isOpen && (
          <div className="DropdownContent">
            <MenuList />
          </div>
        )}
      </div>
    );
  }

  /* ── FULL SIDEBAR  (desktop) ─────────────────────────────────── */
  return (
    <div className="SolumToolSuiteLayout">
      <header className="SolumToolSuiteLayoutHeader">
        <h1>Solum SaaS Suite</h1>
      </header>

      <div className="SolumToolSuiteLayoutContent">
        <nav className="SolumToolSuiteLayoutSidebar">
          <MenuList />
        </nav>

        <main className="SolumToolSuiteLayoutMain">
          {children}
        </main>
      </div>
    </div>
  );
}

export default SolumSaasSuiteLayout;